import { useState } from 'react';
import styles from '../Pasos/EditarPaso.module.css'; 
import {
  FaTrash,
  FaEdit,
  FaEye,
  FaSadCry,
  FaBrain,
  FaMagic,
  FaRocket,
  FaDog,
  FaCat,
  FaBook,
  FaMusic,
  FaPuzzlePiece,
  FaArrowLeft
} from 'react-icons/fa';
import Swal from 'sweetalert2'; 
import { useAuth } from '../../Auth/AuthContext';

//Funciona, pero falta arreglar los estilos xd
//Estilos arreglados :D

const AñadirTest = ({ onBack, onTestAdded }) => {
  const [formData, setFormData] = useState({
    te_nombre: '',
    te_descripcion: '',
    te_icon: 'FaBrain',
    te_tiempo_estimado: '',
    te_instrucciones: '',
    te_tipo_respuesta: 'si_no'
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const {getToken} = useAuth(); 
  const token = getToken(); 
  // Lista de iconos disponibles
  const iconOptions = [
    { value: 'FaRocket', label: 'Cohete', icon: <FaRocket /> },
    { value: 'FaBook', label: 'Libro', icon: <FaBook /> },
    { value: 'FaMusic', label: 'Música', icon: <FaMusic /> },
    { value: 'FaTrash', label: 'Basura', icon: <FaTrash /> },
    { value: 'FaEdit', label: 'Editar', icon: <FaEdit /> },
    { value: 'FaEye', label: 'Ojo', icon: <FaEye /> },
    { value: 'FaSadCry', label: 'Llorar', icon: <FaSadCry /> },
    { value: 'FaBrain', label: 'Cerebro', icon: <FaBrain /> },
    { value: 'FaMagic', label: 'Magia', icon: <FaMagic /> },
    { value: 'FaDog', label: 'Perro', icon: <FaDog /> },
    { value: 'FaCat', label: 'Gato', icon: <FaCat /> },
    { value: 'FaBook', label: 'Libro', icon: <FaBook /> },
    { value: 'FaMusic', label: 'Música', icon: <FaMusic /> },
    { value: 'FaPuzzlePiece', label: 'Puzzle', icon: <FaPuzzlePiece /> },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Limpiar error del campo al escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.te_nombre.trim()) {
      newErrors.te_nombre = 'El nombre del test es obligatorio';
    }

    if (!formData.te_descripcion.trim()) {
      newErrors.te_descripcion = 'La descripción es obligatoria';
    }

    if (formData.te_tiempo_estimado && formData.te_tiempo_estimado < 1) {
      newErrors.te_tiempo_estimado = 'El tiempo estimado debe ser mayor a 0';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    
    try {
      const dataToSend = {
        ...formData,
        te_tiempo_estimado: formData.te_tiempo_estimado ? parseInt(formData.te_tiempo_estimado) : null
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL}/test/crear-test`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
      });

      if (response.ok) {
        Swal.fire({
          title: '¡Paso creado!',
          text:'El paso se ha creado correctamente',
          icon: 'success',
          confirmButtonText: 'Continuar',
          confirmButtonColor: '#242b57',
          timer: 3000,
        }).then(() => {
        
        // Resetear formulario
        setFormData({
          te_nombre: '',
          te_descripcion: '',
          te_icon: 'fi fi-ss-brain',
          te_tiempo_estimado: '',
          te_instrucciones: '',
          te_tipo_respuesta: 'si_no'
        });
        
        if (onTestAdded) {
          onTestAdded();
        }
        
        // Volver a la lista
        if (onBack) {
          onBack();
        }
        })
      } else {
        const errorData = await response.json();
        Swal.fire({
          title: 'Error al crear test',
          text: errorData.error || 'Ocurrió un error en el servidor',
          icon: 'error',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#242b57',
          customClass: {
            popup: 'popupbonito',
          },
          });
      }
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        title: 'Error de conexión',
        text: 'No se pudo conectar con el servidor. Verifica tu conexión a internet.',
        icon: 'error',
        showCancelButton: false, 
        customClass: {
          popup: 'popupbonito',
        },
        });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.formContainerPaso}>
      <div className = {styles.headerSection} >
        <button className={styles.btnBack} onClick={onBack}>
          <FaArrowLeft className={styles.flechaVolver} />
              Volver a test
        </button>
        <h1 className={styles.titulo}>Añadir Test</h1>
      </div>

      <form className={styles.pasoForm} onSubmit={handleSubmit}>
        <div className={styles.formBody}>
          <div className={styles.formSection}>
          <h3>Información Básica</h3>

          <div className={styles.formEdit}>
            <label htmlFor="te_nombre">
              Nombre del Test
            </label>
            <input
              type="text"
              id="te_nombre"
              name="te_nombre"
              value={formData.te_nombre}
              onChange={handleChange}
              placeholder="Ej: Test de Orientación Vocacional"
              className={errors.te_nombre ? 'error' : ''}
              maxLength="255"
            />
            {errors.te_nombre && <p className={styles.mensajeError}>{errors.te_nombre}</p>}
          </div>

          <div className={styles.formEdit}>
            <label htmlFor="te_descripcion">
              Descripción
            </label>
            <textarea
              id="te_descripcion"
              name="te_descripcion"
              value={formData.te_descripcion}
              onChange={handleChange}
              placeholder="Describe brevemente qué evalúa este test y para quién está dirigido..."
              rows="11"
              className={errors.te_descripcion ? 'error' : ''}
            />
            {errors.te_descripcion && <p className={styles.mensajeError}>{errors.te_descripcion}</p>}
          </div>
        </div>

        <div className={styles.formSection}>
          <h3>Configuración Visual</h3>

          <div className={styles.formEdit}>
            <label htmlFor="te_icon">Icono del Test</label>
            <select
              id="te_icon"
              name="te_icon"
              value={formData.te_icon}
              onChange={handleChange}
            >
              {iconOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

            <div className={styles.mt2}>
              <a>Vista previa del ícono: </a>
              {iconOptions.find(opt => opt.value === formData.te_icon)?.icon}
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h3>Detalles del Test</h3>
          
          <div className={styles.formEdit}>
            <label htmlFor="te_tipo_respuesta">Tipo de Respuesta</label>
            <select
              id="te_tipo_respuesta"
              name="te_tipo_respuesta"
              value={formData.te_tipo_respuesta}
              onChange={handleChange}
            >
              <option value="si_no">Sí / No</option>
              <option value="likert">Escala Likert (1-5)</option>
            </select>
          </div>

          <div className={styles.formEdit}>
            <label htmlFor="te_tiempo_estimado">Tiempo Estimado (minutos)</label>
            <input
              type="number"
              id="te_tiempo_estimado"
              name="te_tiempo_estimado"
              value={formData.te_tiempo_estimado}
              onChange={handleChange}
              placeholder="Ej: 15"
              min="1"
              max="999"
              className={errors.te_tiempo_estimado ? 'error' : ''}
            />
            {errors.te_tiempo_estimado && <span className="error-text">{errors.te_tiempo_estimado}</span>}
          </div>

          <div className={styles.formEdit}>
            <label htmlFor="te_instrucciones">Instrucciones del Test</label>
            <textarea
              id="te_instrucciones"
              name="te_instrucciones"
              value={formData.te_instrucciones}
              onChange={handleChange}
              placeholder="Proporciona instrucciones claras sobre cómo realizar el test..."
              rows="6"
            />
          </div>
        </div>
        </div>
        <div className={styles.formActions}>
          <button 
            type="submit" 
            className={styles.btnSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className={styles.btnSpinner}></div>
                Creando...
              </>
            ) : (
              <>
                Crear Test
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AñadirTest;